import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

/**
 * AuthProvider simplifié pour Site B (Paiement)
 * Site B n'a pas d'authentification utilisateur — les paiements sont publics.
 * Ce contexte existe pour compatibilité avec les composants qui l'attendent.
 */
export const AuthProvider = ({ children }) => {
  const [user] = useState(null);
  const [loading] = useState(false);

  const value = {
    user,
    token: null,
    loading,
    login: async () => { throw new Error('Auth non disponible sur Site B'); },
    register: async () => { throw new Error('Auth non disponible sur Site B'); },
    logout: () => {},
    isAuthenticated: false,
    isAdmin: false,
    isVendor: false,
    isClient: false,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
